import { get } from "lodash";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { ROUTING_RESET } from "./router-subscriber-types";

export class RouterSubscriberComponent extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.code !== "" && prevProps.code !== this.props.code) {
      this.route();
      this.props.resetRouterStore();
    }
  }

  route() {
    const {
      code,
      history,
      getState,
      routerMapping,
      errorRoute,
      errorRouteCode
    } = this.props;

    let routeValue;

    if (code === errorRouteCode) {
      routeValue = errorRoute;
    } else {
      routeValue = routerMapping[code];
    }

    if (!routeValue) return;

    if (typeof routeValue === "function") {
      routeValue(code, history);
    } else if (typeof routeValue === "string") {
      history.push(`/${routeValue}`);
    }
  }

  render() {
    const { children } = this.props;
    return <Fragment>{children}</Fragment>;
  }
}

RouterSubscriberComponent.defaultProps = {
  errorRouteCode: "ERROR",
  getState: () => {
    console.log("If you want use getState(), you must pass it in as prop");
  }
};

RouterSubscriberComponent.propTypes = {
  code: PropTypes.string,
  children: PropTypes.element.isRequired,
  history: PropTypes.object.isRequired,
  getState: PropTypes.func,
  routerMapping: PropTypes.object.isRequired,
  errorRoute: PropTypes.string.isRequired,
  errorRouteCode: PropTypes.string
};

const mapStateToProps = state => ({
  code: get(state, "routerSubscriber.code"),
  getState: get(state, "routerSubscriber.getState")
});

const mapDispatchToProps = dispatch => ({
  resetRouterStore: () => dispatch({ type: ROUTING_RESET })
});

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(RouterSubscriberComponent);

export default withRouter(connected);
